export default {
      id: "phone-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.1563a6ab.svg#phone",
      toString: function () {
        return this.url;
      }
    }